var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteHouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 41,
    fill: "#077CA0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8209 57.7184V46.3104H45.1687V57.7184C45.1687 58.9733 46.2203 60 47.5056 60H54.5164C55.8018 60 56.8534 58.9733 56.8534 57.7184V41.7472H60.8262C61.9012 41.7472 62.4153 40.4467 61.5974 39.7622L42.0606 22.5818C41.1725 21.8061 39.8171 21.8061 38.9291 22.5818L19.3923 39.7622C18.5977 40.4467 19.0885 41.7472 20.1634 41.7472H24.1362V57.7184C24.1362 58.9733 25.1879 60 26.4732 60H33.484C34.7693 60 35.8209 58.9733 35.8209 57.7184Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteHouse);
export default __webpack_public_path__ + "static/media/whiteHouse.59e5749b9c3ee35270a1e384d81c6c0c.svg";
export { ForwardRef as ReactComponent };